import React from 'react';

const HeroSection: React.FC = () => {
  const handleWhatsAppDemo = () => {
    const phoneNumber = "919384376329";
    const message = "Hi! I'm interested in learning more about Park Hive parking management system. Can you please provide me with a demo?";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="home" className="pt-32 pb-20 md:pt-40 md:pb-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 mb-12 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-gray-900">
              Parking Management <span className="text-blue-600">System</span>
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-6">
              A Powerful, Fully Digital Parking Management System Designed for High-Traffic, High-Pressure Parking Environments
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-lg">
              Parking should not feel like a battlefield of honking queues, handwritten receipts, lost tickets, and unpredictable delays. Park Hive changes everything with a modern, automated system that gives parking owners complete control from a single mobile app.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold text-blue-900 mb-1">Real-time Tracking</h3>
                <p className="text-blue-700 text-sm">Instant check-in and check-out</p>
              </div>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <h3 className="font-semibold text-green-900 mb-1">Digital Payments</h3>
                <p className="text-green-700 text-sm">Smart pricing & team management</p>
              </div>
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <h3 className="font-semibold text-purple-900 mb-1">Revenue Reporting</h3>
                <p className="text-purple-700 text-sm">All in one place</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button 
                onClick={handleWhatsAppDemo}
                className="bg-blue-600 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-blue-700 transition-colors duration-200"
              >
                Book a Live Demo
              </button>
              <button 
                onClick={handleWhatsAppDemo}
                className="border border-gray-300 text-gray-700 px-8 py-3 rounded-lg text-lg font-medium hover:bg-gray-50 transition-colors duration-200"
              >
                Request a Demo
              </button>
            </div>
            
            <div className="mt-8 flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <p className="text-sm text-gray-600">
                  <span className="font-bold text-green-600">No complicated setup.</span> No heavy hardware. No technical learning curve.
                </p>
              </div>
            </div>
          </div>
          
          <div className="w-full md:w-1/2 relative">
            <div className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-3xl p-2 shadow-xl">
              <img 
                src="https://images.pexels.com/photos/753876/pexels-photo-753876.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
                alt="Modern Parking Facility" 
                className="w-full h-auto rounded-2xl shadow-inner"
              />
            </div>
            
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg hidden md:block">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold text-xs">FAST</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">Smart Parking</p>
                  <p className="text-lg font-bold text-green-600">Simplified</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;